import {
  fork,
  put,
  all,
  call,
  takeLatest,
  delay,
} from "redux-saga/effects";

import {
  ADD_CUSTOM_LICENSE,
  GET_CUSTOM_LICENSES,
  UPDATE_CUSTOM_LICENSE,
  DELETE_CUSTOM_LICENSE,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
} from "./actionTypes";

import {
  addCustomLicense as addCustomLicenseAction,
  addCustomLicenseSuccessful,
  addCustomLicenseFailure,
  getCustomLicenses as getCustomLicensesAction,
  getCustomLicensesSuccessful,
  getCustomLicensesFailure,
  updateCustomLicense as updateCustomLicenseAction,
  updateCustomLicenseSuccessful,
  updateCustomLicenseFailure,
  deleteCustomLicense as deleteCustomLicenseAction,
  deleteCustomLicenseSuccessful,
  deleteCustomLicenseFailure,
  clearAllCustomLicenseMessagesSuccess as clearAllMessagesSuccessAction,
  clearSuccessCustomLicenseMessagesSuccess as clearSuccessMessagesSuccessAction,
  clearFailureCustomLicenseMessagesSuccess as clearFailureMessagesSuccessAction,
} from "./actions";

import {
  addCustomLicense as addCustomLicenseApi,
  getCustomLicenses as getCustomLicensesApi,
  updateCustomLicense as updateCustomLicenseApi,
  deleteCustomLicense as deleteCustomLicenseApi,
} from "../../helpers/auth_helper";

function* getCustomLicenses({payload: { orgcode }}){
    try{
    console.log("Saga, getCustomLicenses");
    //TODO: add parameter, if required
    const response = yield call(getCustomLicensesApi, orgcode);
    console.log("getCustomLicensesApi called, received response: ", response);
    if(response && response.status === 200){
      delete response.status;
      console.log("response of getCustomLicensesApi = ", Object.values(response));
      yield put(getCustomLicensesSuccessful(Object.values(response)));
    }else{
      yield put(getCustomLicensesFailure({message: response.message}));
    }
  } catch(error){
    console.log(
      "getCustomLicensesApi called, received Error is :: ",
      JSON.stringify(error)
    );
    if(error.response){
      yield put(getCustomLicensesFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(getCustomLicensesFailure({message: "No response is received"}))
    } else{
      yield put(getCustomLicensesFailure({message: error?.message}));
    }
  }
}

function* updateCustomLicense({ payload: { customLicense } }) {
  try {
    console.log("Saga, updateCustomLicense, Custom License :: ", customLicense);
    const response = yield call(updateCustomLicenseApi, customLicense);
    console.log("updateCustomLicenseApi called, received response: ", response);
    if (response && response.status === 200) {
      yield put(updateCustomLicenseSuccessful());
    } else {
      let message;
      if (response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(updateCustomLicenseFailure({ message: message }));
    }
  } catch (error) {
    console.log(
      "updateCustomLicenseApi called, received Error is :: ",
      JSON.stringify(error)
    );
    if (error.response) {
      let message;
      if (error.response.data?.message) {
        message = error.response.data?.message;
      } else {
        message = error.response.data;
      }
      console.log("updateCustomLicenseApi error.response=", error.response);
      yield put(updateCustomLicenseFailure({ message: message }));
    } else if (error.request) {
      yield put(
        updateCustomLicenseFailure({ message: "No response is received" })
      );
    } else {
      yield put(updateCustomLicenseFailure({ message: error?.message }));
    }
  }
}

function* addCustomLicense({ payload: { customLicense } }) {
  try {
    console.log("Saga, addCustomLicense, Custom License :: ", customLicense);
    const response = yield call(addCustomLicenseApi, customLicense);
    console.log("addCustomLicenseApi called, received response: ", response);
    if (response && response.status === 200) {
      yield put(addCustomLicenseSuccessful());
    } else {
      let message;
      if (response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(addCustomLicenseFailure({ message: message }));
    }
  } catch (error) {
    console.log(
      "addCustomLicenseApi called, received Error is :: ",
      JSON.stringify(error)
    );
    if (error.response) {
      let message;
      if (error.response.data?.message) {
        message = error.response.data?.message;
      } else {
        message = error.response.data;
      }
      console.log("addCustomLicenseApi error.response=", error.response);
      yield put(addCustomLicenseFailure({ message: message }));
    } else if (error.request) {
      yield put(
        addCustomLicenseFailure({ message: "No response is received" })
      );
    } else {
      yield put(addCustomLicenseFailure({ message: error?.message }));
    }
  }
}

function* deleteCustomLicense({ payload: { orgCode, licenseName} }) {
  try {
    console.log("Saga, deleteCustomLicense");
    const response = yield call(deleteCustomLicenseApi, orgCode, licenseName);
    console.log("deleteCustomLicenseApi called, received response: ", response);
    if (response && response.status === 200) {
      yield put(deleteCustomLicenseSuccessful());
    } else {
      let message;
      if (response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(deleteCustomLicenseFailure({ message: message }));
    }
  } catch (error) {
    console.log(
      "deleteCustomLicenseApi called, received Error is :: ",
      JSON.stringify(error)
    );
    if (error.response) {
      let message;
      if (error.response.data?.message) {
        message = error.response.data?.message;
      } else {
        message = error.response.data;
      }
      console.log("deleteCustomLicenseApi error.response=", error.response);
      yield put(deleteCustomLicenseFailure({ message: message }));
    } else if (error.request) {
      yield put(
        deleteCustomLicenseFailure({ message: "No response is received" })
      );
    } else {
      yield put(deleteCustomLicenseFailure({ message: error?.message }));
    }
  }
}

export function* clearAllMessages() {
  console.log("Saga: clear all messages");
  yield put(clearAllMessagesSuccessAction());
}

export function* clearSuccessMessages() {
  console.log("Saga: clear success messages");
  yield put(clearSuccessMessagesSuccessAction());
}

export function* clearFailureMessages() {
  console.log("Saga: clear failure messages");
  yield put(clearFailureMessagesSuccessAction());
}

function* watchCustomLicense() {
  yield takeLatest(ADD_CUSTOM_LICENSE, addCustomLicense);
  yield takeLatest(GET_CUSTOM_LICENSES, getCustomLicenses);
  yield takeLatest(UPDATE_CUSTOM_LICENSE, updateCustomLicense);
  yield takeLatest(DELETE_CUSTOM_LICENSE, deleteCustomLicense);
  yield takeLatest(CLEAR_ALL_MESSAGES, clearAllMessages);
  yield takeLatest(CLEAR_SUCCESS_MESSAGES, clearSuccessMessages);
  yield takeLatest(CLEAR_FAILURE_MESSAGES, clearFailureMessages);
}

function* customLicenseSaga() {
  yield all([fork(watchCustomLicense)]);
}

export default customLicenseSaga;